/* eslint-disable */
import axios from 'axios'
import config from './config'
import Cookies from 'js-cookie'
// 创建实例
const request = axios.create({
  baseURL: config.url,
  timeout: 100000  // 请求超时100秒
})

// 请求拦截
request.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    config.headers = {
      'Content-Type': 'application/json', //配置请求头
      'box-from': 0,
      'box-token': Cookies.get('token')
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
request.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    if (response.data.code == 201) {
      window.location.href = '/#/login'
    }
    return response.data
  },
  error => {
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)
// 暴露出请求对象
export default request
